import { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material'
import TipoExamenSelector from '../../components/form/TipoExamenSelector/TipoExamenSelector'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import css from './ModalEditarExamen.module.css'

const ModalEditarExamen = ({ open, examen, onClose, onSubmit }) => {
  const [datos, setDatos] = useState({
    nombre: '',
    tipo: '',
    asignaturas: []
  })

  useEffect(() => {
    setDatos({
      nombre: examen?.nombre || '',
      tipo: examen?.tipo || '',
      asignaturas: examen?.asignaturas?.map(asig => asig.id) || []
    })
  }, [open, examen])

  const handleSubmit = () => {
    onSubmit({
      examen: examen.id,
      nombre: datos.nombre,
      tipo: datos.tipo,
      asignaturas: datos.asignaturas
    })
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='sm'>
      <DialogTitle>Editar examen</DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.intro}>
          <TextField
            label='Nombre'
            value={datos.nombre}
            className={css.input}
            variant='standard'
            onChange={e => setDatos({ ...datos, nombre: e.target.value })}
          />
          <TipoExamenSelector
            className={css.input}
            label='Tipo de examen'
            value={datos.tipo}
            onChange={e => setDatos({ ...datos, tipo: e.target.value })}
            variant='standard'
          />
          <AsignaturaSelector
            className={css.input}
            label='Asignaturas'
            multiple={true}
            value={datos.asignaturas}
            onChange={(event, newValue) =>
              setDatos({
                ...datos,
                asignaturas: newValue?.map(asig => asig.id) || []
              })
            }
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button color='primary' onClick={handleSubmit}>
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarExamen
